import styled from "styled-components";
import Image, { ImageType } from "../../Image";
import { useTranslation, useCustomImage } from "../../../hooks";
import { splitNewLines } from "../../../utils";

type Description = { title: string; text: string; margin?: string };
type FeatureType = {
  description: Description;
  image: ImageType;
  size?: string;
  style?: string;
};

const StyledFeature = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 1em;

  .image {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: ${(props: any) => (props.size === "big" ? "initial" : "80%")};

    img {
      max-width: 100%;
      max-height: 25em;
      align-items: center;
    }
  }

  .details {
    max-height: 20%;
    padding-top: 0.5em;

    .description {
      background-image: url(${(props: any) => props.descriptionImage});
      max-width: 15em;
      padding: 0.2em 0.5em;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      .text {
        font-size: 0.7em;
        font-weight: 400;
        line-height: 1.2em;
        p {
          margin: 0;
        }
      }
    }
  }

  @media screen and (max-width: 550px) {
    min-width: 20em;
  }

  ${(props: any) => props.customStyle || ""}
` as any;

const Feature: React.FC<FeatureType> = ({
  image,
  description,
  size,
  style,
}) => {
  return (
    <StyledFeature
      size={size}
      descriptionImage={useCustomImage("paytable/description.webp")}
      highlightImage={useCustomImage("paytable/highlight.webp")}
      customStyle={style}
    >
      <div className="image">
        <Image {...image} />
      </div>
      <div className="details">
        <div className="description">
          <div className="title-bg">
            <div className="title"> {useTranslation(description.title)} </div>
          </div>
          <div className="text">
            {splitNewLines(useTranslation(description.text))}
          </div>
        </div>
      </div>
    </StyledFeature>
  );
};

export default Feature;
